import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { deleteQuiz } from "../../../api/endpoints/QuizEndpoints";

export default function useDeleteQuiz() {
  return useMutation<void, AxiosError, { quizId: number }>({
    mutationKey: ["delete-quiz"],
    mutationFn: ({ quizId }) => deleteQuiz(quizId),
  });
}
